import type { ExposureHint } from "../contract"
import { shortDate } from "../answer/format"
import { Code } from "./Code"

export { FIRMS_CONTACT } from "../pro/ProOverlay"
import { FIRMS_CONTACT } from "../pro/ProOverlay"
import { track } from "@/lib/analytics"

/**
 * Before the notice (NA-Analysis): when each allegation first showed in data the taxpayer already
 * held, and the way to see the next one the month it happens, Nira for firms (NA-Tiers).
 */
export function BeforeTheNotice({ hint, id = "nrd-before" }: { hint: ExposureHint; id?: string }) {
  return (
    <section className="nrd-sec nrd-before" id={id} aria-labelledby={`${id}-h`}>
      <h2 id={`${id}-h`}>Before the notice</h2>
      <p className="nrd-read">{hint.line}</p>
      <div className="nrd-rows">
        {hint.signals.map((s) => (
          <Code
            key={s.id}
            line={<><b>{s.id}</b> · {s.line}</>}
            working={hint.working}
            chip={s.visible_since ? `from ${shortDate(s.visible_since)}` : "on the portal"}
          />
        ))}
      </div>
      <div className="nrd-firms">
        <p className="nrd-firms-k">Nira for firms</p>
        <h3>See the next one the month it happens.</h3>
        <p>
          Your GSTR-2B, registers and ledgers for every entity, connected, reconciled and kept current. Exposure watch flags each of these
          when it first shows, with the amount at risk and the fix, while there is still time to fix it. A person sets it up with you.
        </p>
        <a className="ncf-btn primary" href={FIRMS_CONTACT} onClick={() => track("firms_contact_clicked", { source: "before_the_notice" })}>Talk to us about Nira for firms</a>
      </div>
    </section>
  )
}
